
import { defineComponent, PropType } from 'vue'

const DIVIDER_HEIGHTS = {
  small: 'h-8',
  medium: 'h-10',
  large: 'h-12',
  xlarge: 'h-13'
}

export default defineComponent({
  name: 'ZSplitButtonDropdown',
  props: {
    size: {
      default: 'small',
      type: String as PropType<keyof typeof DIVIDER_HEIGHTS>,
      validator(val: string) {
        return ['small', 'medium', 'large', 'xlarge'].includes(val)
      }
    }
  },
  data() {
    return {
      dividerHeights: DIVIDER_HEIGHTS
    }
  }
})
